import "@/assets/scss/app.scss";
import { KernelInterface } from "@/Kernel/Kernel";
import { Packages } from "@/Resources/packages";

/*
 * Register all packages with the Kernel
 */
for (let i in Packages) {
  if (Packages.hasOwnProperty(i)) {
    KernelInterface.registerPackage(Packages[i]);
  }
}

/*
 * Register the Base translations for the platform.
 */
KernelInterface.build();

/*
 * Initialize the Vue application
 */
import("@/VueResources/init");
